import { render, staticRenderFns } from "./RecipientMultiSelector.vue?vue&type=template&id=c641c7ca&"
import script from "./RecipientMultiSelector.vue?vue&type=script&lang=js&"
export * from "./RecipientMultiSelector.vue?vue&type=script&lang=js&"
import style0 from "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./RecipientMultiSelector.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports